import React, { useEffect } from 'react';
import SimulationCard from '../../atoms/SimulationCard/SimulationCard';
import './MyHistoryPanel.css';

const MyHistoryPanel = ({
  currentUserId,
  simsByUser,
  selectedSimId,
  onLoadSims,
  onSelectSim,
}) => {
  const data = simsByUser[currentUserId];

  useEffect(() => {
    if (currentUserId && !data) onLoadSims(currentUserId);
  }, [currentUserId, data, onLoadSims]);

  if (!currentUserId) {
    return <div className="my-history-message">Aucun utilisateur connecté</div>;
  }

  // Gestion de l'erreur en priorité (même si loading est true)
  if (data?.error) {
    return <div className="my-history-message">Erreur : {data.error}</div>;
  }

  if (data?.loading) {
    return (
      <div className="my-history-loading">
        <div className="my-history-spinner" />
        <span></span>
      </div>
    );
  }

  if (!data?.sims?.length) {
    return <div className="my-history-message">Aucune simulation disponible</div>;
  }

  return (
    <div className="my-history-panel">
      {data.sims.map((sim, index) => (
        <SimulationCard
          key={sim.fire?.id ?? index}
          simulation={sim}
          isSelected={selectedSimId === sim.fire?.id}
          onClick={onSelectSim}
        />
      ))}
    </div>
  );
};

export default MyHistoryPanel;